var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeed3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_10679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.842773 20.5518C0.842773 20.5518 5.93277 18.0718 6.71277 17.8418C7.50277 17.6118 11.5328 17.6318 12.2128 16.0018C12.8928 14.3718 12.5528 12.3418 15.5928 11.2718",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6929 23.6318C47.6929 23.6318 42.0129 22.1818 40.3829 21.3418C38.7929 20.5218 36.3129 17.2918 35.3829 16.3418C34.3729 17.3218 32.6629 19.3418 30.2429 19.3418C26.7129 19.3418 25.1929 16.3818 21.0029 15.6718C19.3929 17.2718 16.2129 20.7118 15.5929 21.0518C14.9729 21.3918 8.74289 21.6918 7.48289 22.0518C6.20289 22.4118 3.48289 23.6318 1.71289 24.6318",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.382812 12.3418C1.50281 12.3418 4.78281 12.3118 6.55281 10.9218C9.21281 8.84182 12.4028 6.85182 17.3828 8.34182C22.3428 9.83182 25.4828 9.77182 28.3828 9.34182C31.3128 8.90182 34.8728 6.77182 37.8528 6.46182",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7123 4.45181L39.9823 6.24181C42.4223 6.74181 43.7523 8.21181 44.4023 8.66181C44.6123 8.80181 44.5323 9.68181 44.4323 10.2718C44.7223 10.4918 45.3923 11.1118 45.3923 11.3518C45.3923 11.5918 44.3123 12.7418 43.4323 13.1018C42.4723 13.4918 40.1423 12.4418 39.4023 12.0118",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6924 1.34183H14.6924",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6924 1.34183H10.6924",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69238 1.34183H6.69238",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6924 28.3418H27.6924",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6924 28.3418H23.6924",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6924 28.3418H19.6924",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_10679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.56,
    height: 29,
    fill: "white",
    transform: "translate(0.382812 0.341827)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed3);
export default __webpack_public_path__ + "static/media/speed_3.e0adfc7560d555e93821933693650c93.svg";
export { ForwardRef as ReactComponent };